<template>
  <svg xmlns="http://www.w3.org/2000/svg" :class="[size, 'size']" viewBox="0 0 37.66 37.66">
    <g>
      <path class="cls-1" d="M37.19.47c-.62-.62-1.64-.62-2.26,0l-11.56,11.56v-2.67c0-.88-.72-1.6-1.6-1.6s-1.6.72-1.6,1.6v6.53c0,.11.01.21.03.32,0,.04.02.07.03.11.02.06.03.13.06.19.02.04.04.08.06.12.03.05.05.11.09.16.03.05.07.08.1.13.03.04.06.08.09.12.03.03.07.06.1.08.05.04.09.08.14.11.04.03.09.05.14.08.05.02.09.05.14.07.05.02.11.03.16.05.05.01.09.03.14.04.1.02.21.03.31.03h6.53c.88,0,1.6-.72,1.6-1.6s-.72-1.6-1.6-1.6h-2.67l11.56-11.56c.62-.62.62-1.64,0-2.26Z"/>
      <path class="cls-1" d="M17.46,21.46s-.02-.07-.03-.11c-.02-.06-.03-.13-.06-.19-.02-.04-.04-.08-.06-.12-.03-.05-.05-.11-.09-.16-.03-.05-.07-.08-.1-.13-.03-.04-.06-.08-.09-.12-.03-.03-.07-.05-.1-.08-.05-.04-.09-.08-.14-.11-.04-.03-.09-.05-.14-.07-.05-.03-.09-.05-.14-.07-.05-.02-.1-.03-.15-.05-.05-.02-.1-.04-.15-.05-.07-.01-.15-.02-.22-.02-.03,0-.06,0-.09,0h-6.53c-.88,0-1.6.72-1.6,1.6s.72,1.6,1.6,1.6h2.67L.47,34.93c-.62.62-.62,1.64,0,2.26.31.31.72.47,1.13.47s.82-.16,1.13-.47l11.56-11.56v2.67c0,.88.72,1.6,1.6,1.6s1.6-.72,1.6-1.6v-6.53c0-.11-.01-.21-.03-.32Z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IcReduction',
  props: {
    size: {
      type: String,
      default: 'md'
    }
  }
}
</script>

<style lang="scss" scoped>
.size {
  width: 1em;
  height: 1em;
  fill: currentColor;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
